<template>
  <main class="content">
    <FullScreenSlider
      :slides="4"
      :accent-dots-index="[1, 3]"
      dots-accent-color="#888888"
      dots-base-color="#11111138"
      @dismiss="dismiss"
    >
      <Slide
        class="slide"
        v-for="(item, i) in lottieAnimations"
        v-bind:key="i"
        :style="{ background: i % 2 !== 0 ? 'white' : '#2c7040' }"
      >
        <div class="d-flex flex-column mt-4">
          <div class="slide-text px-3" :class="[i === 0 && 'mb-5 pb-5']">
            <div v-html="t(`CL_NEW_INTRO_SLIDER.SLIDE_TEXT_${i + 1}`)"></div>
          </div>
          <div
            class="slide-animation px-2"
            :class="[i === 0 && 'first-slide-animation']"
          >
            <Vue3Lottie
              :animationData="item"
              :loop="true"
              :speed="1"
              :autoPlay="true"
            />
          </div>
        </div>
      </Slide>
    </FullScreenSlider>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Slide } from "vue3-carousel";
import FullScreenSlider from "@/apps/credit-line/components/FullScreenSlider.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import slide_1 from "@/assets/lottie-animations/Swipe_intro1.json";
import slide_2 from "@/assets/lottie-animations/Swipe_intro2.json";
import slide_3 from "@/assets/lottie-animations/Swipe_intro3.json";
import slide_4 from "@/assets/lottie-animations/Swipe_intro4.json";
import { Vue3Lottie } from "vue3-lottie";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useRoute, useRouter } from "vue-router";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";

declare const Android: AndroidInterface;

export default defineComponent({
  name: "OnboardingSliderView",
  methods: { useAsset },
  components: { Vue3Lottie, FullScreenSlider, Slide },
  mounted() {
    Android.finishedLoading();
  },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const lottieAnimations = [slide_1, slide_2, slide_3, slide_4];

    const dismiss = () => {
      if (route.query?.fromHelp) {
        return router.back();
      }

      return Android.dismissWebView();
    };

    return { t, lottieAnimations, dismiss };
  },
});
</script>

<style lang="scss" scoped>
* {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}

.slide {
  min-height: 100%;
  width: 100%;
  padding: 20% 0 27% 0;
  overflow: hidden;
}

.slide-text {
  margin-bottom: 3%;
  text-align: center;
}

.slide-animation {
  height: 35rem;
  width: 100%;
  margin-bottom: -3%;
}

.first-slide-animation {
  height: 18rem;
  margin-bottom: -35%;
  margin-left: 6%;
}
</style>
